import React, { useState, useEffect } from 'react';

import { Main, SForm, BoardsPreloader } from './styled';
import TaskItem from './TaskItem';
import { createTask } from '../../../firebase/api/tasks-public';
import { usePublicTasks } from '../../../firebase/api/tasks-public';
import { useInvitations } from '../../../firebase/api/invitations';

const TasksPage: React.FC<{
  boardId: string;
}> = (props) => {
  const { tasks: allTasks, loading } = usePublicTasks(props.boardId);
  const [taskName, setTaskName] = useState('');
  const [trackingTaskId, setTrackingTaskId] = useState('');
  const { invitations } = useInvitations();

  const boardIdsIHaveInvited = invitations?.map((el) => el.id);

  useEffect(() => {
    setTrackingTaskId('');
  }, [props.boardId]);

  const sortedTasks = allTasks
    .sort((a, b) => (a.rank || 0) - (b.rank || 0))
    .filter((t) => t.status !== 'done');

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    const el = document.getElementById('task-create-input');
    e.preventDefault();
    createTask(props.boardId, taskName, 'todo', sortedTasks.length);
    setTaskName('');
    el?.focus();
  };

  return (
    <Main>
      <SForm onSubmit={submit}>
        <input
          autoComplete="off"
          id="task-create-input"
          value={taskName}
          onChange={(e) => setTaskName(e.target.value)}
          placeholder="Что нужно сделать..."
        />
      </SForm>
      {loading ? (
        <BoardsPreloader />
      ) : (
        sortedTasks.map((t, index, self) => (
          <TaskItem
            {...t}
            key={t.id}
            self={self}
            index={index}
            boardId={props.boardId}
            canBeTracked={boardIdsIHaveInvited && boardIdsIHaveInvited.includes(props.boardId)}
            setTrackingTaskId={setTrackingTaskId}
            trackingTaskId={trackingTaskId}
          />
        ))
      )}
    </Main>
  );
};

export default TasksPage;
